import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';
import foodBenefitWorkTeamComponent from './foodBenefitWorkTeam.component';

let foodBenefitWorkTeamModule = angular.module('foodBenefitWorkTeam', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider
    .state(STATES.FOOD_BENEFIT.WORK_TEAM, {
      url: ROUTES.FOOD_BENEFIT.WORK_TEAM,
      component: 'foodBenefitWorkTeam',
      data: {
        requiresAuth: true,
      },
    });
})

.component('foodBenefitWorkTeam', foodBenefitWorkTeamComponent)

.name;

export default foodBenefitWorkTeamModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitWorkTeam/foodBenefitWorkTeam.js